export enum AspectRatio {
  Original = 'original',
  Square = '1x1',
  Standard = '16x9',
  Wide = '384x143',
  Ultrawide = '636x175',
}
export type LooseAspectRatio = AspectRatio | `${AspectRatio}`
